
import React, { useState, forwardRef, useRef, useEffect } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails, Card, CardContent, CardActions, Divider,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import styles from '../styles.module.css';
import PartiesAdd from './masters/parties/PartiesAdd';
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from './reusableComponent/BootstrapDialog';
import { getDocNoFormateAvailable, getInvoiceSettingList } from '../actions/actions';
import { useDispatch, useSelector } from 'react-redux';


const PartiesOverallDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const docNoFormateAvailable = useSelector(state => state.docNoFormate.docNoFormateAvailable)
    const invoiceSettingList = useSelector(state => state.invoiceSetting.invoiceSetting)

    useEffect(() => {
        dispatch(getInvoiceSettingList({ companyId: userInfo.companyId }))
    }, []);

    const navigateToLink = (row, url) => {

        if (url === 'PO') {
            dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Purchase Order' }))
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
                docNoFormateAvailable,
            };
            navigate('/purchase/add-purchase-order', { state });
        } else if (url === 'PI') {
            dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Purchase Invoice' }))
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
                docNoFormateAvailable,
            };
            navigate('/purchase/add-purchase-invoice', { state });
        } else if (url === 'SP') {
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
            };
            navigate('/purchase/supplier-payment', { state });
        } else if (url === 'SO') {
            dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Sales Order' }))
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
                docNoFormateAvailable,
                invoiceSettingList,
            };
            navigate('/sales/add-sales-order', { state });
        } else if (url === 'SI') {
            dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Sales Invoice' }))
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
                docNoFormateAvailable,
                invoiceSettingList,
            };
            navigate('/sales/add-sales-invoice', { state });
        } else if (url === 'CP') {
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
            };
            navigate('/sales/customer-payment', { state });
        } else if (url === 'ACstatement') {
            const state = {
                row: undefined,
                prName: {
                    CNS_Name: row.CNS_Name,
                    CNS_Type: row.CNS_Type,
                    CSNId: row.CSNId,
                    emailId: row.emailId,
                    gstn: row.gstn,
                    address: row.address,
                    pinCode: row.pinCode,
                    state: row.state,
                },
            };
            navigate('/reports/account-statement', { state });
        } else {
            const state = {
                ...row,
            };
            navigate('/masters/add-party-masters', { state });
        }

    };
    return (
        <>

            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>

                <Box>
                    <Grid container spacing={2}>
                        <Grid item md={9}>
                            <Grid container spacing={2}>
                                <Grid item xs={1.8} >
                                    <Typography className={`${styles.detail_lable}`}>{detailsView.CNS_Type == 'Supplier' ? 'Supplier' : 'Customer'} Name</Typography>
                                </Grid>
                                <Grid item xs={0.5} >
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.7} >
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px', }}  >{detailsView.CNS_Name}</Typography>
                                </Grid>
                                <Grid item xs={1.8} >
                                    <Typography className={`${styles.detail_lable}`}>{detailsView.CNS_Type == 'Supplier' ? 'Supplier' : 'Customer'} Since</Typography>
                                </Grid>
                                <Grid item xs={0.5} >
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.7} >
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px', }}  >{detailsView.partySince}</Typography>
                                </Grid>
                                <Grid item xs={1.8} >
                                    <Typography className={`${styles.detail_lable}`}>Total Due</Typography>
                                </Grid>
                                <Grid item xs={0.5} >
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9.7} >
                                    {detailsView.CNS_Type == 'Supplier' ?
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#cc0000' }} >{parseFloat(detailsView.totalPayable).toFixed(2)}</Typography>
                                        :
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#0000cc' }} >{parseFloat(detailsView.totalReceivable).toFixed(2)}</Typography>
                                    }
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
                                <Grid item md={4}>
                                    <Card sx={{ minWidth: 275, backgroundColor:'#baf5ed' }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                <Typography variant="h6" component="div">
                                                    Current Month
                                                </Typography>
                                            </Box>
                                            <Grid container spacing={0} >
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total Orders</Typography>
                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#0dd43b', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseOrderMonth : detailsView.totalSalesOrderMonth}</Typography>

                                                </Grid>
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total Transactions</Typography>
                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#214dad', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseTransactionMonth : detailsView.totalSalesTransactionMonth}</Typography>

                                                </Grid>
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total {detailsView.CNS_Type == 'Supplier' ? 'Purchase' : 'Sales'}</Typography>

                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#8a0d8f', fontWeight: 'bold', fontSize: '18px' }}> {detailsView.CNS_Type == 'Supplier' ? parseFloat(detailsView.totalPurchaseAmtMonth).toFixed(2) : parseFloat(detailsView.totalSalesAmountMonth).toFixed(2)}</Typography>

                                                </Grid>

                                            </Grid>
                                        </CardContent>

                                    </Card>
                                </Grid>
                                <Grid item md={4}>
                                    <Card sx={{ minWidth: 275 , backgroundColor:'#f9ccff'}}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                <Typography variant="h6" component="div">
                                                    Current Year
                                                </Typography>
                                            </Box>
                                            <Grid container spacing={0} >
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total Orders</Typography>
                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#0dd43b', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseOrderYear : detailsView.totalSalesOrderYear}</Typography>

                                                </Grid>
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total Transactions</Typography>
                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#214dad', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseTransactionYear : detailsView.totalSalesTransactionYear}</Typography>

                                                </Grid>
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total {detailsView.CNS_Type == 'Supplier' ? 'Purchase' : 'Sales'}</Typography>

                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#8a0d8f', fontWeight: 'bold', fontSize: '18px' }}> {detailsView.CNS_Type == 'Supplier' ? parseFloat(detailsView.totalPurchaseAmtYear).toFixed(2) : parseFloat(detailsView.totalSalesAmountYear).toFixed(2)}</Typography>

                                                </Grid>
                                            </Grid>
                                        </CardContent>

                                    </Card>
                                </Grid>
                                <Grid item md={4}>
                                    <Card sx={{ minWidth: 275, backgroundColor:'#e1ffcc' }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                <Typography variant="h6" component="div">
                                                    As on Date
                                                </Typography>
                                            </Box>
                                            <Grid container spacing={0} >
                                                <Grid item xs={5}>
                                                    <Typography className={`${styles.detail_lable}`}>Total Orders</Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography sx={{ color: '#0dd43b', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseOrderTillDate : detailsView.totalSalesOrderTillDate}</Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                    <Typography className={`${styles.detail_lable}`}>Total Transactions</Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography sx={{ color: '#214dad', fontWeight: 'bold', fontSize: '18px' }}>{detailsView.CNS_Type == 'Supplier' ? detailsView.totalPurchaseTransactionTillDate : detailsView.totalSalesTransactionTillDate}</Typography>

                                                </Grid>
                                                <Grid item xs={5} >
                                                    <Typography className={`${styles.detail_lable}`}>Total {detailsView.CNS_Type == 'Supplier' ? 'Purchase' : 'Sales'}</Typography>
                                                </Grid>
                                                <Grid item xs={1} >
                                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                                </Grid>
                                                <Grid item xs={6} >
                                                    <Typography sx={{ color: '#8a0d8f', fontWeight: 'bold', fontSize: '18px' }}> {detailsView.CNS_Type == 'Supplier' ? parseFloat(detailsView.totalPurchaseAmtTillDate).toFixed(2) : parseFloat(detailsView.totalSalesAmountTillDate).toFixed(2)}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>

                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={3} sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', }}>
                            <Grid container spacing={1} >
                                <Grid item md={12} >
                                    <Box sx={{}}>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                                            <NavLink>
                                                <Icon icon="clarity:email-line" width="19" height="22" color="red" style={{ marginRight: '10px', }} />
                                            </NavLink>
                                            <Divider orientation="vertical" />
                                            {/* <NavLink> */}
                                            <EditIcon style={{ marginLeft: '10px', float: 'left', fontSize: '22px', cursor: 'pointer' }} onClick={() => navigateToLink(detailsView, 'edit')} />
                                            {/* </NavLink> */}
                                        </Box>

                                    </Box>
                                </Grid>
                            </Grid>
                            <Box sx={{ marginBottom: '10px',display:'block', justifyContent:'center',alignItems:'center'}}>
                                <Button variant="contained" className={`${styles.redirect_btn}`} onClick={() => navigateToLink(detailsView, detailsView.CNS_Type == 'Supplier' ? 'PO' : 'SO')}>
                                    <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Make {detailsView.CNS_Type == 'Supplier' ? 'Purchase Order' : 'Sales Order'}
                                </Button>
                                <Button variant="contained" className={`${styles.redirect_btn}`} onClick={() => navigateToLink(detailsView, detailsView.CNS_Type == 'Supplier' ? 'PI' : 'SI')}>
                                    <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Make {detailsView.CNS_Type == 'Supplier' ? 'Purchase Invoice' : 'Sales Invoice'}
                                </Button>
                                <Button variant="contained" className={`${styles.redirect_btn}`} onClick={() => navigateToLink(detailsView, detailsView.CNS_Type == 'Supplier' ? 'SP' : 'CP')} >
                                    <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Make {detailsView.CNS_Type == 'Supplier' ? 'Supplier' : 'Customer'} Payment
                                </Button>
                                <Button variant="contained" className={`${styles.redirect_btn}`} onClick={() => navigateToLink(detailsView, 'ACstatement')} >
                                    <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Generate A/C Statement
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

            </Paper>
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        maxHeight: 600,
                        minWidth: "30%",
                        minHeight: 120
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Update Party
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <PartiesAdd handleCloseDialog={handleClose} details={detailsView} />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}
export default PartiesOverallDetails;